module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp3_5012.acc91f44.png";